'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');

function _interopNamespace(e) {
    if (e && e.__esModule) return e;
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function (k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function () {
                        return e[k];
                    }
                });
            }
        });
    }
    n['default'] = e;
    return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);

const Svg24 = (props) => (React__namespace.createElement("svg", Object.assign({ width: 24, height: 25, viewBox: "0 0 24 25", fill: "none" }, props),
    React__namespace.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M21.0005 12.9927C21.0005 17.9635 16.971 21.993 12.0002 21.993C7.02951 21.993 2.99994 17.9635 2.99994 12.9927C2.99994 8.022 7.02951 3.99243 12.0002 3.99243C16.971 3.99243 21.0005 8.022 21.0005 12.9927ZM23.0005 12.9927C23.0005 19.068 18.0755 23.993 12.0002 23.993C5.92494 23.993 0.999939 19.068 0.999939 12.9927C0.999939 6.91743 5.92494 1.99243 12.0002 1.99243C18.0755 1.99243 23.0005 6.91743 23.0005 12.9927ZM13.4696 8.45916C13.4696 9.2707 12.8117 9.92858 12.0002 9.92858C11.1886 9.92858 10.5308 9.2707 10.5308 8.45916C10.5308 7.64763 11.1886 6.98975 12.0002 6.98975C12.8117 6.98975 13.4696 7.64763 13.4696 8.45916ZM12.001 11.2985C12.6637 11.2985 13.201 11.8358 13.201 12.4985L13.201 18.2073C13.201 18.87 12.6637 19.4073 12.001 19.4073C11.3382 19.4073 10.801 18.87 10.801 18.2073V12.4985C10.801 11.8358 11.3382 11.2985 12.001 11.2985Z", fill: props.fillColor, fillOpacity: 0.92 })));

exports.default = Svg24;
//# sourceMappingURL=24.js.map
